import AntTime from '../utils/AntTime';
import AntLocalization from '../utils/AntLocalization';
import AntCondition from '../utils/AntCondition';
import format from 'string-format';

const TRANSLATIONS = {
    NONE: { vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई khổng', ar: 'لا شيء' },
    DISTRICT_PREFIX: { vi: 'Quận', en: 'Dist', fr: 'District', es: 'Distrito', id: 'Distrik', ja: '地区', zh: '区', ko: '구역', hi: 'जिला', ar: 'منطقة' },
    TODAY: { vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' },
    YESTERDAY: { vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीta)', ar: 'أمس' },
    TOMORROW: { vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल', ar: 'غداً' },
    REMAIN: { vi: 'Còn', en: 'Remain', fr: 'Reste', es: 'Quedan', id: 'Sisa', ja: '残り', zh: '剩余', ko: '남은', hi: 'शेष', ar: 'متبقي' },
    PERIOD: { vi: 'kỳ', en: 'period', fr: 'période', es: 'período', id: 'periode', ja: '期間', zh: '期', ko: '기간', hi: 'अवधि', ar: 'فترة' },
    WEEKDAYS: {
        1: { vi: 'Thứ Hai', en: 'Monday', fr: 'Lundi', es: 'Lunes', id: 'Senin', ja: '月曜日', zh: '星期一', ko: '월요일', hi: 'सोमवार', ar: 'الإثنين' },
        2: { vi: 'Thứ Ba', en: 'Tuesday', fr: 'Mardi', es: 'Martes', id: 'Selasa', ja: '火曜日', zh: '星期二', ko: '화요일', hi: 'मंगलवार', ar: 'الثلاثاء' },
        3: { vi: 'Thứ Tư', en: 'Wednesday', fr: 'Mercredi', es: 'Miércoles', id: 'Rabu', ja: '水曜日', zh: '星期三', ko: '수요일', hi: 'बुधवार', ar: 'الأربعاء' },
        4: { vi: 'Thứ Năm', en: 'Thursday', fr: 'Jeudi', es: 'Jueves', id: 'Kamis', ja: '木曜日', zh: '星期四', ko: '목요일', hi: 'गुरुवार', ar: 'الخميس' },
        5: { vi: 'Thứ Sáu', en: 'Friday', fr: 'Vendredi', es: 'Viernes', id: 'Jumat', ja: '金曜日', zh: '星期五', ko: '금요일', hi: 'शुक्रवार', ar: 'الجمعة' },
        6: { vi: 'Thứ Bảy', en: 'Saturday', fr: 'Samedi', es: 'Sábado', id: 'Sabtu', ja: '土曜日', zh: '星期六', ko: '토요일', hi: 'शनिवार', ar: 'السبت' },
        7: { vi: 'Chủ Nhật', en: 'Sunday', fr: 'Dimanche', es: 'Domingo', id: 'Minggu', ja: '日曜日', zh: '星期日', ko: '일요일', hi: 'रविवार', ar: 'الأحد' }
    }
};

export default class AntCardViewUtil {
    constructor(config, tableName) {
        this.config = config;
        this.tableName = tableName;
    }

    initFieldConfig(field) {
        const strField = field.cnfField || field.dataField;
        const found = this.config.getCnfField(strField, field.cnfTable);

        const obj = {
            dataField: field.dataField,
            table: field.cnfTable,
            cnf: found,
            dataType: field.dataType || found?.dataType || null,
            alignment: found?.alignment !== undefined ? found.alignment : field.alignment
        };

        const labelRaw = field.label || found?.gridLabel || found?.label || null;
        obj.label = AntLocalization.translateText(AntCondition.getValue({}, labelRaw));

        let lookupValues = field.lookup?.values instanceof Array ? field.lookup.values : found?.lookup?.values instanceof Array ? found.lookup.values : null;
        if (lookupValues instanceof Array) {
            obj.lookupValues = lookupValues.map((c) => ({
                ...c,
                name: AntLocalization.translateText(AntCondition.getValue({}, c.name))
            }));
        } else {
            obj.lookupValues = null;
        }

        if (!obj.alignment) {
            if (['currency', 'float', 'decimal', 'int'].includes(obj.dataType)) obj.alignment = 'right';
        }

        return obj;
    }

    _handleVisibleOnMain(visibleOnMain, data) {
        if (!visibleOnMain) return true;
        let vObj = visibleOnMain;
        if (Array.isArray(visibleOnMain)) {
            vObj = visibleOnMain.find(v =>
                v.table === this.tableName ||
                v.table?.includes?.(this.tableName) ||
                v.tables?.includes?.(this.tableName)
            )?.value;
        }
        return vObj ? AntCondition.isVisible(data, { visible: vObj }) : true;
    }

    isFieldVisible(props, cell, data) {
        if (cell.visible === true) return true;
        if (cell.visible === false) return false;

        let visible = AntCondition.isVisible(data, cell);
        if (visible && cell.visibleOnMain) {
            visible = this._handleVisibleOnMain(cell.visibleOnMain, data);
        }

        let cellCnf;
        if (visible && cell.dataField) {
            const cnfTable = cell.cnfTable || this.tableName;
            cellCnf = this.initFieldConfig({
                dataField: cell.dataField,
                dataType: cell.dataType,
                cnfTable: cnfTable,
                cnfField: cell.cnfField
            });

            if (cellCnf?.cnf) {
                visible = AntCondition.isVisible(null, cellCnf.cnf);
                if (visible && cellCnf.cnf.visibleOnMain) {
                    visible = this._handleVisibleOnMain(cellCnf.cnf.visibleOnMain, data);
                }
                if (visible && cellCnf.cnf.visibleSelf) {
                    visible = AntCondition.isVisible(data, { visible: cellCnf.cnf.visibleSelf });
                }
            }
        }

        if (visible && props.filterGroup) {
            if (cellCnf?.cnf?.visibleFilterGroups instanceof Array) {
                visible = cellCnf.cnf.visibleFilterGroups.includes(props.filterGroup);
            }
            if (visible && cell.visibleFilterGroups instanceof Array) {
                visible = cell.visibleFilterGroups.includes(props.filterGroup);
            }
        }

        if (visible && cell.visible?.type === 'action' && cell.visible.field) {
            const condKey = Object.keys(props.searchConditions).find(k => k === cell.visible.field);
            if (condKey && props.searchConditions[condKey] !== undefined) {
                visible = props.searchConditions[condKey] === cell.visible.value;
            }
        }

        if (cell?.showWhenSelected) return visible && Boolean(props.isSelected || props.isActive);

        return visible;
    }

    formatFieldValue(props, cell, data, fValue, _cellCnf) {
        let cellCnf = _cellCnf;
        if (!cellCnf && cell.dataField) {
            const cnfTable = cell.cnfTable || this.tableName;
            cellCnf = this.initFieldConfig({
                dataField: cell.dataField,
                dataType: cell.dataType,
                cnfTable: cnfTable,
                cnfField: cell.cnfField
            });
        }

        const cnf = cellCnf?.cnf;
        let dataType = cell.dataType || cellCnf?.dataType || cnf?.dataType;
        dataType = AntCondition.getValue(data, dataType);

        const lookupValues = cellCnf?.lookupValues;
        if (Array.isArray(lookupValues) && data) {
            const valueField = cell.valueField || cnf?.lookup?.valueField || 'code';
            const displayField = cell.displayField || cnf?.lookup?.displayField || 'name';

            let newValue = fValue;
            if (fValue != null) {
                const obj = lookupValues.find(f => f[valueField] === fValue);
                if (obj) newValue = obj[displayField];
            }

            if (cell.customDisplay) newValue = cell.customDisplay(data);
            else if (cnf?.customDisplay) newValue = cnf.customDisplay(data);

            return newValue === null || newValue === undefined ? '' : String(newValue);
        }

        let newValue = fValue;

        if (dataType === 'Array' && !cell.dataField && Array.isArray(cell.fields)) {
            const noneText = AntLocalization.translateText(TRANSLATIONS.NONE);
            const distPrefix = AntLocalization.translateText(TRANSLATIONS.DISTRICT_PREFIX);

            newValue = cell.fields.map(field => {
                const isObj = typeof field === 'object' && field !== null;
                if (isObj && field.visible === false) return;

                const fName = isObj ? field.dataField : field;
                let curFValue = data[fName];
                let visible = (cell.visible === true);

                if (!visible) visible = this.isFieldVisible(props, { dataField: fName }, data);

                if (isObj && field.dataField && (!visible || field.visible !== undefined)) {
                    if (field.visible === true) visible = true;
                    else visible = AntCondition.isVisible(data, { visible: field.visible });

                    if (field.visibleOnMain) {
                        visible = visible && AntCondition.isVisible(props.parentData, { visible: field.visibleOnMain });
                    }
                }

                if (visible) {
                    const tName = cell.cnfTable || this.tableName;
                    const cnf2 = this.initFieldConfig({ dataField: field, cnfTable: tName });
                    let formatted = this.formatFieldValue(props, { dataField: field }, data, curFValue, cnf2);

                    if (formatted === noneText && cell.displayNoneAsEmpty !== false) formatted = '';
                    if (formatted == null) formatted = '';

                    if (formatted && !isNaN(parseInt(formatted)) && String(fName).endsWith('_adm2_name')) {
                        formatted = `${distPrefix} ${formatted}`;
                    }
                    return formatted;
                }
            }).filter(v => v !== undefined && v !== 0 && v !== null && String(v).trim() !== '');

            if (cell.selectTop) newValue = newValue.join(',').split(',').slice(0, cell.selectTop);
        } else if (dataType === 'int') {
            newValue = AntLocalization.translateInteger(fValue);
        } else if (dataType === 'float' || dataType === 'decimal') {
            newValue = AntLocalization.translateDecimal(fValue);
        } else if (dataType === 'percent') {
            newValue = `${AntLocalization.translateInteger(Math.floor(parseFloat(fValue) * 100))} %`;
        } else if (dataType === 'day') {
            const lbl = AntLocalization.translateText({ vi: 'ngày', en: fValue > 1 ? 'days' : 'day', fr: fValue > 1 ? 'jours' : 'jour', es: fValue > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: fValue > 1 ? 'أيام' : 'يوم' });
            newValue = `${AntLocalization.translateInteger(fValue)} ${lbl}`;
        } else if (dataType === 'month' && data && data[cell.dataField] != null) {
            const val = parseFloat(data[cell.dataField]);
            if (val) {
                newValue = String(val).length > 6 ? AntTime.fromUnix(val).format('MM/YYYY') : AntTime.fromString(format('{0}-{1}-01 00:01', Math.floor(val / 100), val % 100)).format('MM/YYYY');
            }
        } else if (dataType === 'year' && data && data[cell.dataField] != null) {
            const val = parseFloat(data[cell.dataField]);
            if (val) {
                newValue = String(val).length > 6 ? AntTime.fromUnix(val).format('YYYY') : AntTime.fromString(format('{0}-01-01 00:01', parseInt(val))).format('YYYY');
            }
        } else if (dataType === 'period') {
            const lbl = AntLocalization.translateText(TRANSLATIONS.PERIOD);
            newValue = `${AntLocalization.translateInteger(fValue)} ${lbl}`;
        } else if (dataType === 'currency') {
            newValue = AntLocalization.translateCurrency(fValue, cell.showSign !== undefined ? cell.showSign : cnf?.showSign || false);
        } else if (dataType === 'date') {
            if (!fValue) newValue = '';
            else if (AntTime.isUnixWithinToDay(fValue)) {
                newValue = cell.showTimeWithinToday ? AntTime.fromUnix(fValue).format('hh:mm A ') : AntLocalization.translateText(TRANSLATIONS.TODAY);
            } else if (AntTime.isUnixWithinYesterday(fValue)) newValue = AntLocalization.translateText(TRANSLATIONS.YESTERDAY);
            else if (AntTime.isUnixWithinTomorrow(fValue)) newValue = AntLocalization.translateText(TRANSLATIONS.TOMORROW);
            else newValue = AntTime.fromUnix(fValue).format(AntTime.isUnixWithinCurrentYear(fValue) ? 'DD/MM' : 'DD/MM/YY');
        } else if (dataType === 'datetime') {
            if (!fValue) newValue = '';
            else if (AntTime.isUnixWithinToDay(fValue)) newValue = AntTime.fromUnix(fValue).format('hh:mm A');
            else newValue = AntTime.fromUnix(fValue).format(AntTime.isUnixWithinCurrentYear(fValue) ? 'DD/MM HH:mm' : 'DD/MM/YY');
        } else if (dataType === 'weekday') {
            if (!fValue) newValue = '';
            else {
                const day = AntTime.fromUnix(fValue).isoWeekday();
                newValue = AntLocalization.translateText(TRANSLATIONS.WEEKDAYS[day] || '');
            }
        } else if (dataType === 'duration') {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            if (!fValue) newValue = '';
            else {
                const minutes = Math.ceil(AntTime.diffMinuteToNow(fValue, true));
                const absMin = Math.abs(minutes);
                const vDays = Math.floor(absMin / (60 * 24));
                const vHours = Math.floor(absMin / 60) - vDays * 24;
                const vMinutes = absMin % 60;

                let parts = [];
                if (vDays) parts = [format('{0}d', vDays), vHours ? format('{0}h', vHours) : null];
                else if (vHours) parts = [format('{0}h', vHours), vMinutes ? format('{0}m', vMinutes) : null];
                else parts = [vMinutes ? format('{0} {1}', vMinutes, AntLocalization.translateText({ vi: 'phút', en: vMinutes > 1 ? 'minutes' : 'minute', fr: vMinutes > 1 ? 'minutes' : 'minute', es: vMinutes > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: vMinutes > 1 ? 'دقائق' : 'دقيقة' })) : null];

                let str = parts.filter(Boolean).join(' ');
                if (minutes < 0) str = format('{1} {0}', str, AntLocalization.translateText(TRANSLATIONS.REMAIN));
                newValue = str;
            }
        } else if (dataType === 'minute' || dataType === 'minutes' || dataType === 'hour' || dataType === 'hours') {
            let val = cell.customCellValue ? cell.customCellValue(data) : fValue;
            if (!cell.customCellValue && cell.dataUOMField) {
                const uom = data[cell.dataUOMField];
                if (dataType.startsWith('minute') && uom === 'HOUR') val *= 60;
                else if (dataType.startsWith('minute') && uom === 'DAY') val *= 1440;
                else if (dataType.startsWith('hour') && uom === 'DAY') val *= 24;
            }

            if (!val) newValue = '';
            else {
                const totalMin = Math.ceil(dataType.startsWith('hour') ? val * 60 : val);
                const absMin = Math.abs(totalMin);
                const d = Math.floor(absMin / 1440);
                const h = Math.floor((absMin % 1440) / 60);
                const m = absMin % 60;

                const dayLbl = { vi: 'ngày', en: d > 1 ? 'days' : 'day', fr: d > 1 ? 'jours' : 'jour', es: d > 1 ? 'días' : 'día', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: d > 1 ? 'أيام' : 'يوم' };
                const hrLbl = { vi: 'giờ', en: h > 1 ? 'hours' : 'hour', fr: h > 1 ? 'heures' : 'heure', es: h > 1 ? 'horas' : 'hora', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: h > 1 ? 'ساعات' : 'ساعة' };
                const minLbl = { vi: 'phút', en: m > 1 ? 'minutes' : 'minute', fr: m > 1 ? 'minutes' : 'minute', es: m > 1 ? 'minutos' : 'minuto', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: m > 1 ? 'دقائق' : 'دقيقة' };

                let parts = [];
                if (d) parts = [format('{0} {1}', d, AntLocalization.translateText(dayLbl)), h ? format('{0} {1}', h, AntLocalization.translateText(hrLbl)) : null];
                else if (h) parts = [format('{0} {1}', h, AntLocalization.translateText(hrLbl)), m ? format('{0} {1}', m, AntLocalization.translateText(minLbl)) : null];
                else parts = [m ? format('{0} {1}', m, AntLocalization.translateText(minLbl)) : null];

                newValue = parts.filter(Boolean).join(' ');
            }
        } else if (['join', 'first', 'last'].includes(dataType) && Array.isArray(cell.fields)) {
            if (cell.customCellValue) newValue = cell.customCellValue(data);
            const ar = [];
            const noneText = AntLocalization.translateText(TRANSLATIONS.NONE);
            const distPrefix = AntLocalization.translateText(TRANSLATIONS.DISTRICT_PREFIX);

            for (const fField of cell.fields) {
                let fnd = this.config.getCnfField(fField, this.tableName);
                if (fnd?.cnfTable) fnd = this.config.getCnfField(fnd.cnfField, fnd.cnfTable);
                if (fnd?.visibleSelf && !AntCondition.isVisible(data, { visible: fnd.visibleSelf })) continue;

                const vF = fnd?.lookup?.valueField || 'code';
                const dF = fnd?.lookup?.displayField || 'name';
                const vals = fnd?.lookup?.values || [];

                let curV = data[fField];
                if (curV != null) {
                    const foundObj = vals.find(f => f[vF] === curV);
                    if (foundObj) curV = foundObj[dF];
                }
                curV = AntLocalization.translateText(curV);
                if (curV === noneText && cell.displayNoneAsEmpty !== false) curV = '';
                if (curV != null && !isNaN(parseInt(curV)) && String(fField).endsWith('_adm2_name')) curV = `${distPrefix} ${curV}`;

                ar.push(curV || '');
            }

            const cleanAr = ar.filter(Boolean).map(String);
            newValue = dataType === 'join' ? cleanAr.join(cell.separator || ', ') : dataType === 'first' ? cleanAr.shift() : cleanAr.pop();
        }

        if ((cell.prefix || cellCnf?.prefix) && newValue) {
            const p = AntCondition.getValue(data, cell.prefix || cellCnf.prefix);
            if (p) newValue = `${AntLocalization.translateText(p)} ${newValue}`;
        }
        if ((cell.postfix || cellCnf?.postfix) && newValue) {
            const p = AntCondition.getValue(data, cell.postfix || cellCnf.postfix);
            if (p) newValue = `${newValue} ${AntLocalization.translateText(p)}`;
        }

        if (cell.showWithText) {
            const lblRaw = cell.rawLabel || cell.label || cellCnf?.rawLabel || cellCnf?.label;
            if (lblRaw) {
                const strText = AntLocalization.translateText(AntCondition.getValue(data, lblRaw));
                if (strText) newValue = `${strText} ${newValue}`;
            }
        }

        return newValue;
    }

    isRowVisible({ props, row, item }) {
        return row.cells.some(cell => {
            let val = item[cell.dataField];
            if (cell.dataField && cell.hideWhenEmpty && (!val || String(val).trim() === '')) return false;

            if (!this.isFieldVisible(props, cell, item)) return false;

            const cnfTable = cell.cnfTable || this.tableName;
            const cellCnf = this.initFieldConfig({
                dataField: cell.dataField,
                dataType: cell.dataType,
                cnfTable: cnfTable,
                cnfField: cell.cnfField
            });
            val = this.formatFieldValue(props, cell, item, val, cellCnf);
            return val !== undefined && val !== null && String(val).trim() !== '';
        });
    }

    getVisibileRows(args) {
        return args.layout.rows.filter((row, i) => this.isRowVisible({
            props: args.props,
            row: row,
            item: args.item,
            index: i
        }));
    }

    getVisibileRowsCount(card) {
        const layout = card.cardLayout || {};
        const getCount = (key) => layout[key] ? this.getVisibileRows({ props: card.props, layout: layout[key], item: card.item, key }).length : 0;
        return getCount('header') + getCount('main') + getCount('footer');
    }
}
